import { render, staticRenderFns } from "./costAccountingColumnsList.vue?vue&type=template&id=1656a1b6&scoped=true&"
import script from "./costAccountingColumnsList.vue?vue&type=script&lang=js&"
export * from "./costAccountingColumnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1656a1b6",
  null
  
)

export default component.exports